import Service from '../Service';
import { addFingerprintToRequest } from './utils';
import Request from '../Request';
import { ResponseErrorBody, RequestParamsSetupPassword } from '../../types';

export default async function(
  webToken: string,
  params: RequestParamsSetupPassword
) {
  const request = await addFingerprintToRequest(
    new Request(`/api/auth/login/${webToken}/password/set`)
      .setMethod('POST')
      .setPayload(params)
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
